import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  text: 'Before this system, I was spending my entire Sunday writing programs for my 15 athletes. Now I use the Session Builder and Ready-To-Use Workouts to get it all done in under an hour. My athletes are hitting PRs and I finally have my weekends back.',
  author: 'Mark D.',
  role: 'Head Running Coach',
  location: 'Colorado, USA'
}, {
  text: 'The Running Drill Library alone is worth ten times the price. I used to struggle with explaining biomechanics and drills to beginners, but the frameworks provided here make it incredibly simple and effective.',
  author: 'Sarah W.',
  role: 'Endurance Coach & PT',
  location: 'London, UK'
}, {
  text: 'I coach a local running club with over 40 members of varying abilities. The Program Design module helped me structure our entire season so everyone from 5K beginners to marathoners gets exactly what they need without me burning out.',
  author: 'David R.',
  role: 'Running Club Director',
  location: 'Toronto, AUS'
}, {
  text: 'As a newer coach, I had major imposter syndrome. I knew how to run, but coaching others was terrifying. This 6-in-1 system gave me the professional structure and confidence I needed to start charging premium rates.',
  author: 'Jessica L.',
  role: 'Private Running Coach',
  location: 'Texas, USA'
}, {
  text: 'The Race Day Success System bonus completely changed how my athletes perform under pressure. We went from having constant pacing issues and race anxiety to executing perfect negative splits. Incredible resource.',
  author: 'Tom H.',
  role: 'Marathon Coach',
  location: 'New York, USA'
}];
export function Testimonials() {
  return <section className="py-12 px-4 sm:px-6 bg-brand-paper border-y-4 border-brand-navy" data-id="element-168">
      <div className="text-center mb-10" data-id="element-169">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-2 uppercase leading-tight" data-id="element-170">
          ⭐ 4.9/5 — VERIFIED PROFESSIONAL REVIEWS
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-171">
        {testimonials.map((t, i) => <div key={i} className={`bg-white border border-gray-200 p-6 rounded-xl shadow-md relative ${i === testimonials.length - 1 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-172">
            <Quote className="absolute top-4 right-4 w-10 h-10 text-brand-paper" data-id="element-173" />
            <div className="flex gap-1 mb-4" data-id="element-174">
              {[...Array(5)].map((_, s) => <Star key={s} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-175" />)}
            </div>
            <p className="text-brand-ink/90 font-medium mb-6 leading-relaxed text-sm italic relative z-10" data-id="element-176">
              "{t.text}"
            </p>
            <div className="border-t border-gray-100 pt-4 flex items-center gap-3" data-id="element-177">
              <div className="w-12 h-12 rounded-full bg-brand-navy text-white flex items-center justify-center font-bold text-lg shadow-inner" data-id="element-178">
                {t.author.charAt(0)}
              </div>
              <div className="leading-tight" data-id="element-179">
                <p className="font-bold text-brand-navy text-sm mb-1" data-id="element-180">
                  {t.author}
                </p>
                <p className="text-[11px] text-brand-ink/60 font-bold uppercase tracking-wide" data-id="element-181">
                  {t.role} — {t.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}